import { render, staticRenderFns } from "./CompareVehicleMenu.vue?vue&type=template&id=458eecfc"
import script from "./CompareVehicleMenu.vue?vue&type=script&lang=js"
export * from "./CompareVehicleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.44_css-loader@7.1.5_webpack@5.112.2__ejs@3.1.1_ee2c7053b1d68e4067351b3e8f0482a3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports